// import _ from 'lodash';
import moment from 'moment';
import { notification } from 'antd';
import misc from 'misc/misc';
import platforms from 'misc/platforms';

export default {
  showNotification(type, title, content) {
    if (platforms.isInRniOSWebView()) {
      const webViewBridge = platforms.getClientWebViewBridge();
      const toastStr = (title && content) ? `${title}: ${content}` : `${title}${content}`;
      webViewBridge.showLongToast(toastStr);
    } else {
      // For Android & web, use JS notification. We don't use the app's toast in Android
      // because Android's toast may be blocked if app notification permission is not granted.
      switch (type) {
        case 'success':
          notification.success({
            message: title,
            description: content || undefined,
          });
          break;
        case 'warning':
          notification.warning({
            message: title,
            description: content || undefined,
          });
          break;
        case 'failure':
          notification.error({
            message: title,
            description: content || undefined,
          });
          break;
        default:
          break;
      }
    }
  },

  /**
   * Converts minutes to decimal hours string. Note that the use of toFixed simply cuts at
   * two decimal places. No rounding will be done.
   */
  min2DecimalHour(minutes) {
    const decimalHours = minutes / 60;
    return decimalHours.toFixed(2);
  },

  /**
   * Converts minutes to clock hours string. E.g. 05:12.
   */
  min2ClockHour(minutes) {
    const duration = moment.duration(minutes, 'minutes');
    return Math.floor(duration.asHours()) + moment.utc(duration.asMilliseconds()).format(':mm');
  },

  /**
   * Converts a number to its dollar notation. E.g. 1234.5 -> $1,234.50
   */
  toDollars(decimal) {
    if (decimal === undefined || decimal === null) {
      return '';
    }

    // This is a hackish way to fix the im-precision of float numbers, e.g.:
    // x.1249999999999999 is actually x.125 and should be rounded to x.13,
    // but if we don't do this add, a direct toFixed(2) would return x.12.
    // For float numbers like x.1200000000000001 or x.119999999999999, this
    // add operation does not affect the toFixed(2) result anyway.
    const decimal2 = decimal + 0.00000001;
    return `$${decimal2.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  },

  base64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  },

  createGroupState(remoteObjects, prefix, valueExtractorFunc) {
    const groupState = {};

    remoteObjects.forEach((remoteObject) => {
      groupState[`${prefix}-${remoteObject.getId()}`] = valueExtractorFunc(remoteObject);
    });

    return groupState;
  },

  extraFormInputValue(values, name) {
    const value = values[name];
    return value === undefined ? null : value;
  },

  extraFormInputNumberValue(values, name) {
    const value = values[name];
    return value === undefined ? null : value;
  },

  extraFormTextAreaValue(values, name) {
    const value = values[name];
    return value === undefined ? null : value;
  },

  extraFormTimeValue(values, name) {
    return misc.toTimeString(values[name]);
  },

  extraFormDateValue(values, name) {
    return misc.toDateString(values[name]);
  },

  extraFormDateTimeMidNightValue(values, name) {
    return values[name] ? misc.toDateTimeString(values[name].startOf('day')) : '';
  },

  extraFormDateTimeEndOfDayValue(values, name) {
    return values[name] ? misc.toDateTimeString(values[name].endOf('day')) : '';
  },

  extraFormDateTimeValue(values, name) {
    return misc.toDateTimeString(values[name]);
  },

  extraFormSelectValue(values, name) {
    const value = values[name];

    if (value && typeof value === 'object') {
      return value.value; // react-select
    } else {
      return value === undefined ? null : value; // antd Select.
    }
  },

  extraFormCheckboxGroupValue(values, name) {
    const value = values[name];
    return value === undefined ? null : value;
  },
};
